import { useState } from 'react';
import { X, Search, ArrowUpDown, ChevronDown } from 'lucide-react';

// Predefined list for declaracion_2 (Casilla 1.2 - PROCEDIMIENTO ADUANERO)
export function getDeclaraciones2() {
  return [
    { 
      codigo: "A", 
      nombre: "Declaración normal (procedimiento normal, artículo 162 del CAU). Esta clave será también la utilizada en las declaraciones acogidas al procedimiento de domiciliación cuando deba presentarse en la Aduana de forma previa al levante de la mercancía." 
    },
    { 
      codigo: "B", 
      nombre: "Declaración simplificada por falta de datos (cantidad o valor provisional, artículo 166 del CAU). Debe utilizarse esta clave cuando se trate de declaraciones provisionales por no conocerse los datos definitivos o faltar algún documento." 
    },
    { 
      codigo: "C", 
      nombre: "Declaración simplificada por falta de datos (supuesto distinto del previsto con la letra B, artículo 166 del CAU)." 
    },
    { 
      codigo: "D", 
      nombre: "Predeclaración normal (tal como se contempla en el código A) de conformidad con el artículo 171 del Código." 
    },
    { 
      codigo: "E", 
      nombre: "Predeclaración simplificada (tal como se contempla en el código B) de conformidad con el artículo 171 del Código." 
    },
    { 
      codigo: "F", 
      nombre: "Predeclaración simplificada (tal como se contempla en el código C) de conformidad con el artículo 171 del Código." 
    },
    { 
      codigo: "X", 
      nombre: "Declaración complementaria de declaración simplificada tipo B." 
    },
    { 
      codigo: "Y", 
      nombre: "Declaración complementaria de declaración simplificada tipo C." 
    },
    { 
      codigo: "Z", 
      nombre: "Declaración complementaria en el contexto de un procedimiento simplificado de inscripción en los registros (artículos 166 y 182 del CAU)." 
    },
  ];
}

export const Declaracion2Modal = ({
  declaraciones = [],
  isOpen,
  onClose,
  onSelect,
  selectedDeclaracion,
  title = 'Select Declaration 2',
  isSpanish = true,
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [sortBy, setSortBy] = useState('code-asc');
  const [isSortOpen, setIsSortOpen] = useState(false);

  const sortOptions = [
    { value: 'code-asc', label: isSpanish ? 'Código (A-Z)' : 'Code (A-Z)' },
    { value: 'code-desc', label: isSpanish ? 'Código (Z-A)' : 'Code (Z-A)' },
    { value: 'name-asc', label: isSpanish ? 'Nombre (A-Z)' : 'Name (A-Z)' },
    { value: 'name-desc', label: isSpanish ? 'Nombre (Z-A)' : 'Name (Z-A)' },
  ];

  const filteredDeclaraciones = declaraciones.filter((declaracion) =>
    declaracion.nombre.toLowerCase().includes(searchQuery.toLowerCase()) ||
    declaracion.codigo.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const sortedDeclaraciones = [...filteredDeclaraciones].sort((a, b) => {
    switch (sortBy) {
      case 'code-asc':
        return a.codigo.localeCompare(b.codigo);
      case 'code-desc':
        return b.codigo.localeCompare(a.codigo);
      case 'name-asc':
        return a.nombre.localeCompare(b.nombre);
      case 'name-desc':
        return b.nombre.localeCompare(a.nombre);
      default:
        return 0;
    }
  });

  const getSortLabel = () => {
    return sortOptions.find((option) => option.value === sortBy)?.label || (isSpanish ? 'Ordenar por' : 'Sort by');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl mx-4">
        <div className="flex justify-between items-center mb-4">
          <div>
            <h2 className="text-xl font-bold">{isSpanish ? 'PROCEDIMIENTO ADUANERO (Oblig.)' : 'CUSTOMS PROCEDURE (Obligatory)'}</h2>
            <p className="text-sm text-gray-600 mt-1">
              {isSpanish 
                ? "Identifica el procedimiento aduanero solicitado para las mercancías objeto del tráfico, con las siguientes claves:"
                : "Identifies the customs procedure requested for the goods subject to traffic, with the following keys:"}
            </p>
          </div>
          <button
            onClick={() => {
              setSearchQuery('');
              setIsSortOpen(false);
              onClose();
            }}
            className="p-1 hover:bg-gray-100 rounded-full"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="flex gap-2 mb-4">
          {/* Search Input */}
          <div className="relative flex items-center gap-2 border-container rounded-full px-3 py-1 flex-1 flex-row">
            <div className="flex-0 pointer-events-none">
              <Search className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              className="pr-4 py-2 !border-none no-border search-input"
              style={{ borderWidth: '0px !important', border: '0px !important' }}
              placeholder={isSpanish ? "Buscar procedimiento..." : "Search procedure..."}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          {/* Custom Sort Dropdown */}
          <div className="relative button-no-hover-effect text-sm">
            <button
              className="flex items-center gap-2 px-2 pr-0 py-2 rounded-full"
              onClick={() => setIsSortOpen(!isSortOpen)}
            >
              <ArrowUpDown className="w-4 h-4" />
              <span>{getSortLabel()}</span>
              <ChevronDown className={`w-4 h-4 transition-transform ${isSortOpen ? 'rotate-180' : ''}`} />
            </button>

            {isSortOpen && (
              <div className="overflow-hidden absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg border-container py-1 z-10">
                {sortOptions.map((option) => (
                  <button
                    key={option.value}
                    className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${
                      sortBy === option.value ? 'text-primary' : 'text-gray-700'
                    }`}
                    onClick={() => {
                      setSortBy(option.value);
                      setIsSortOpen(false);
                    }}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="max-h-[60vh] min-h-[60vh] overflow-y-auto">
          {declaraciones.length > 0 ? (
            <div className="space-y-0">
              {sortedDeclaraciones.length > 0 ? (
                sortedDeclaraciones.map((declaracion) => (
                  <div
                    key={declaracion.codigo}
                    className={`p-3 px-0 hover:bg-gray-100 cursor-pointer border-bottom-gray ${
                      selectedDeclaracion &&
                      (selectedDeclaracion?.codigo === declaracion.codigo || selectedDeclaracion === declaracion.codigo || (typeof selectedDeclaracion === 'string' && selectedDeclaracion === declaracion.codigo))
                        ? 'bg-gray-100 font-bold'
                        : ''
                    }`}
                    onClick={() => {
                      onSelect(declaracion);
                      setSearchQuery('');
                      setIsSortOpen(false);
                      onClose();
                    }}
                  >
                    <div className="flex justify-between items-start gap-2">
                      <div className="flex-1">
                        <div className="flex items-center gap-2 mb-1">
                          <span className="font-bold text-lg">{declaracion.codigo}</span>
                        </div>
                        <p className="text-sm text-gray-700">{declaracion.nombre}</p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center py-4 text-gray-500">
                  {isSpanish 
                    ? `No se encontraron procedimientos que coincidan con "${searchQuery}"`
                    : `No procedures found matching "${searchQuery}"`}
                </div>
              )}
            </div>
          ) : (
            <div className="text-center py-4">
              <p className='opacity-75 mb-4'>{isSpanish ? 'No hay procedimientos disponibles' : 'No Procedures Available'}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

